export let life = {}
export let event = {
  inputValue (e) {
    if (!e.target.value) return
     let val = e.target.value.toString().replace(/[^\d\.]/g, '')
     val = val.replace(/(\.\d*)\..*/, '$1')
    e.target.value = val
  },
  blurInput (e) {
    console.log(e)
    if (!e.target.value) {
      e.target.value = 0
    }
  }
}
export let watch = {}
